import {cn} from "@/lib/utils";
import {AppTitle} from "@/app/components/common/app-title/AppTitle";
import * as React from "react";
import {HTMLAttributes, ReactNode} from "react";

interface IProps extends HTMLAttributes<HTMLDivElement> {
    title: string;
    children?: ReactNode;
}

export const GoBackHeaderContainer = ({title, className, children, ...props}: IProps) => {
    return (
        <div className={cn('flex items-center gap-[10px] flex-nowrap', className)} {...props}>
            <div>
                {children}
            </div>
            <AppTitle className={'uppercase text-[24px] leading-[99%] tracking-[-6%]'}>{title}</AppTitle>
        </div>
    )
}
